define.alias("checkout/components/seamless-checkout-table/line-item-section", "settings/components/seamless-checkout-table/line-item-section");